import { render } from "./CmsLifecycleStateBadge.vue?vue&type=template&id=efa0c778&scoped=true"
import script from "./CmsLifecycleStateBadge.vue?vue&type=script&lang=js"
export * from "./CmsLifecycleStateBadge.vue?vue&type=script&lang=js"

import "./CmsLifecycleStateBadge.vue?vue&type=style&index=0&id=efa0c778&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efa0c778"]])

export default __exports__